// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title-view-credential-btn-e9204{margin-left:16px;position:absolute;right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view-credential-btn": "title-view-credential-btn-e9204",
	"viewCredentialBtn": "title-view-credential-btn-e9204"
};
export default ___CSS_LOADER_EXPORT___;
